import type { ReactNode } from 'react'

import cx from 'classnames'

import styles from './input.module.css'

interface SelectWrapperProps extends React.HTMLAttributes<HTMLDivElement> {
  children: ReactNode
  label: string
  required?: boolean
  errorMessage?: string
}

export function SelectWrapper ({ children, label, required, errorMessage, className, ...rest }: SelectWrapperProps): JSX.Element {
  return (
    <div
      className={cx(styles.inputWrapper, className)}
      {...rest}
    >
      <label
        className={styles.inputLabel}
      >
        {label} {required && (<span style={{ position: 'absolute', top: -3, right: -7, fontSize: '1rem', color: 'red' }}>*</span>)}
      </label>
      {children}

      {errorMessage && (
        <span style={{ paddingTop: '0.25rem', paddingLeft: '0.375rem', fontSize: '0.75rem', display: 'block', color: '#ff4e47' }}>
          {errorMessage}
        </span>
      )}
    </div>
  )
}
